import { Component, Input } from '@angular/core'
import {
  MbAbstractInformationTileComponent
} from '../mb-abstract-information-tile/mb-abstract-information-tile.component'
import { BaseSiteService } from '@spartacus/core'
import { map } from 'rxjs/operators'
import { MbCheckoutReviewInfoType } from '../../../../models'

@Component({
  selector: 'mb-checkout-information-tile',
  templateUrl: './mb-checkout-information-tile.component.html',
  styleUrls: ['./mb-checkout-information-tile.component.scss']
})
export class MbCheckoutInformationTileComponent extends MbAbstractInformationTileComponent {

  infoTypes = MbCheckoutReviewInfoType
  supportingAccountCreation$ = this.baseSiteService.get().pipe(
    map(activeBaseSite => !!activeBaseSite?.supportingAccountCreation)
  )
  supportingGuestCheckout$ = this.baseSiteService.get().pipe(
    map(activeBaseSite => !!activeBaseSite?.supportingGuestCheckout)
  )

  @Input() type: MbCheckoutReviewInfoType | undefined

  constructor (protected baseSiteService: BaseSiteService) {
    super()
  }
}
